module.exports = __webpack_public_path__ + "img/icon_map_3_on_011.b04bac6b.png";